export default __webpack_public_path__ + "static/media/Q.9518c845.svg";